import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=2e4667f1&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=2e4667f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4667f1",
  null
  
)

export default component.exports